import { KText } from '@/ui-library/components/text';

export const NAText = ({ text }) => {
  return (
    <KText fontSize="sm" color="secondary-500">
      {text}
    </KText>
  );
};
